import { Injectable, Inject } from '@angular/core';
import { Log } from './log-models';
import { Observable } from 'rxjs';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    private authService: AuthService,
    @Inject(CORE_CONFIG) private coreConfig: any) {
      this._baseURL = `${this.coreConfig.endpoint}api/v1/log`;
    }

  getLogList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<Log>> {
    return this.httpClient.get<AutoTablePageableResponse<Log>>(`${this._baseURL}s`, {
      params: params
    });
  }
}
